import FileManager from './file-manager'

/**
 * File Manager plugin
 *
 * @param {Object} Vue
 */
function plugin (Vue) {
  if (plugin.installed) {
    return
  } else {
    plugin.installed = true
  }

  return Vue.$file || new FileManager(Vue)
}

export default plugin
